import { setConversationId } from 'actions/workflows-v2/workflowsV2';
import { useAppDispatch, useAppSelector } from 'hooks';
import { useEffect } from 'react';
import {
  selectConversationId,
  selectWorkflowsConfig,
} from 'reducers/workflows';

const useSynchronizeConversationId = () => {
  const dispatch = useAppDispatch();
  const conversationId = useAppSelector(selectConversationId);
  const workflowsConfig = useAppSelector(selectWorkflowsConfig);

  useEffect(() => {
    if (
      workflowsConfig?.conversation_id !== undefined &&
      conversationId !== workflowsConfig?.conversation_id
    ) {
      dispatch(setConversationId(workflowsConfig?.conversation_id));
    }
  }, [dispatch, conversationId, workflowsConfig?.conversation_id]);
};

export default useSynchronizeConversationId;
